import UAParser from "ua-parser-js"
import _ from "lodash"
import { useAuthStore } from "@/store"
import { isArray, isString } from "@/utils"
/** 获取设备信息 */
export function useDeviceInfo() {
    const parser = new UAParser()
    const result = parser.getResult()
    return result
}

/** 权限判断 */
export function usePermission() {
    const auth = useAuthStore()

    function hasPermission(permission: Auth.RoleType | Auth.RoleType[]) {
        const { roles } = auth.userInfo

        let has = roles.some((r) => r === "super")
        if (!has) {
            if (isArray(permission)) {
                has = Boolean(_.intersection(roles, permission).length)
            }
            if (isString(permission)) {
                has = roles.some((r) => r === permission)
            }
        }
        return has
    }

    /**
     * 按权限码判断，跟后端 @PreAuthorize("@ss.hasPermi(...)") 同一套权限码字符串
     * （如 "system:tenentOrder:approve"），超级管理员固定命中 "*:*:*" 直接放行。
     * 用于按钮级权限判断，粒度比 hasPermission（角色级）更细。
     */
    function hasPermi(code: string | string[]) {
        const permissions = auth.userInfo.permissions || []
        if (permissions.includes("*:*:*")) return true
        const codes = isArray(code) ? code : [code]
        return Boolean(_.intersection(permissions, codes).length)
    }

    return {
        hasPermission,
        hasPermi,
    }
}
